<template>
  <div :class="$style.wrap">
    安全项重置（可多选）
    <van-checkbox-group direction="horizontal" v-model="selectResult">
      <van-checkbox
        shape="square"
        :name="item.id"
        v-for="(item, index) in list"
        :key="index"
        >{{ item.name }}</van-checkbox
      >
    </van-checkbox-group>
  </div>
</template>
<script>
export default {
  name: "TheCheckboxGroup",
  props: {
    checkInfo: Object
  },
  data() {
    return {
      selectResult: this.$ls.get("resetId") || []
    };
  },
  computed: {
    list() {
      return this.checkInfo.list;
    }
  },
  watch: {
    /**
     * @description 选择复选框
     * @param {array}} val  - 复选框值
     */
    selectResult(val) {
      this.$emit("getCheckResult", val);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  margin-top: 0.2rem;
  padding: 0 0.5rem;
  font-size: 0.28rem;
  :global {
    .van-checkbox-group {
      margin-top: 0.2rem;
    }
    .van-checkbox {
      margin-top: 0.2rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
